import api from './APIService';

class RelationshipService {
	relationshipFinder($field,$value) {
		return api.fetch({ method: 'get', path: '/participant/riders/relationship/relationshipFinder/'+$field+'/'+$value});
	}
	showLinkedMembers($idUserRole) {
		return api.fetch({ method: 'get', path: '/participant/riders/relationship/getLinkedMembers/'+$idUserRole });
	}
	getMyAccountManager() {
		return api.fetch({ method: 'get', path: '/participant/riders/relationship/getMyAccountManager/' });
	}
	getYourAccountManager() {
		return api.fetch({ method: 'get', path: '/participant/riders/relationship/getYourAccountManager' });
	}
	showLinkedMembersAccMan() {
		return api.fetch({ method: 'get', path: '/participant/riders/relationship/getLinkedMembersAccMan/'});
	}
	relationshipCreator(data) {
		return api.fetch({ method: 'post', path: '/participant/riders/relationship', data });
	}
	showRelationshipValues(){
		return api.fetch({ method: 'get', path: '/participant/riders/relationship/getRelationshipValues' });
	}
	relationshipUpdate(data){
		return api.fetch({ method: 'put', path: '/participant/riders/relationship', data });
	}
	relationshipDelete($relId){
		return api.fetch({ method: 'delete', path: '/participant/riders/relationship/' + $relId });
	}
	getUserRoles() {
		return api.fetch({ method: 'get', path: '/participant/riders/relationship/getUserRoles/' });
	}
}

export default new RelationshipService();
